// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1NsRl","savePackageButton":"ClientWallet_savePackageButton__ehkrI"};